module.exports = __webpack_public_path__ + "static/assets/4c0a55e7bbffb0045b58b584f77d21ea.svg";